export const chartDataFunc =(lineLabels,isMobile,ticker,lineData,lineData2)=> ({
    labels: lineLabels,
    datasets: [
      {
        label: isMobile ? ticker : "Stock",
        type: "line",
        data: lineData,
        borderColor: "#71B37C",
        pointBorderColor: "#71B37C",
        pointBackgroundColor: "#71B37C",
        pointHoverBackgroundColor: "#71B37C",
        pointHoverBorderColor: "#71B37C",
        spanGaps: true,
        lineTension: 0,
        yAxisID: "y-axis-1",
      },
      {
        type: "line",
        label: "IV",
        data: lineData2,
        borderColor: "#FCFFCC",
        hoverBackgroundColor: "#FCFFCC",
        hoverBorderColor: "#FCFFCC",
        borderWidth: 0.5, // and not lineWidth
        spanGaps: true,
        lineTension: 0,
        yAxisID: "y-axis-2",
      },
    ],
  });

  export const chartOptionsFunc =(ticker, lineLabels)=> ({
    responsive: true,
    // tooltips: {
    //     mode: 'label'
    // },
    tooltips: {
      enabled: true,
      intersect: false,
      mode: "index",

      backgroundColor: "darkblue",
    },
    hover: {
      mode: "index",
      intersect: false,
    },

    mouseLine: {
      color: "grey",
    },
    responsiveAnimationDuration: 500,

    title: {
      display: true,
      text: ticker + "  Stock Price & Option IV",
      fontSize: 16,
      fontColor: "#fff",
    },
    legend: {
      display: true,
    },
    elements: {
      line: {
        fill: false,
      },
      point: {
        radius: 0,
      },
    },
    layout: {
      padding: {
        left: 5,
        right: 5,
        top: 5,
        bottom: 5,
      },
    },
    scales: {
      xAxes: [
        {
          display: true,
          gridLines: {
            color: "white",
            display: false,
          },
          ticks: {
            fontColor: "white",
          },
          labels: lineLabels,
        },
      ],
      yAxes: [
        {
          type: "linear",
          display: true,
          position: "left",
          id: "y-axis-1",
          gridLines: {
            color: "#222",
            display: true,
          },
          ticks: {
            fontColor: "#71B37C",
          },
          labels: {
            labelMaxWidth: "10px",

            show: true,
          },
        },
        {
          labelMaxWidth: "10px",
          type: "linear",
          display: true,
          position: "right",
          id: "y-axis-2",
          gridLines: {
            color: "white",
            display: false,
          },
          ticks: {
            fontColor: "#FCFFCC",
          },
          labels: {
            show: true,
          },
        },
      ],
    },
  });
  export const chartOptionsMobileFunc =(ticker,lineLabels)=> ({
    responsive: true,
    maintainAspectRatio: true,
    // tooltips: {
    //     mode: 'label'
    // },
    tooltips: {
      enabled: true,
      intersect: false,
      mode: "index",

      backgroundColor: "darkblue",
    },
    hover: {
      mode: "index",
      intersect: false,
    },

    mouseLine: {
      color: "grey",
    },
    responsiveAnimationDuration: 500,

    title: {
      display: false,
      text: ticker + "  Stock Price & Option IV",
      fontSize: 12,
      fontColor: "#fff",
    },
    legend: {
      display: true,
      labels: {
        fontColor: "white",
      },
    },
    elements: {
      line: {
        fill: false,
      },
      point: {
        radius: 0,
      },
    },
    layout: {
      padding: {
        left: 0,
        right: 0,
        top: 0,
        bottom: 0,
      },
    },
    scales: {
      xAxes: [
        {
          display: true,
          gridLines: {
            color: "white",
            display: false,
          },
          ticks: {
            fontColor: "white",
          },
          labels: lineLabels,
        },
      ],
      yAxes: [
        {
          type: "linear",
          display: true,
          position: "left",
          id: "y-axis-1",
          gridLines: {
            color: "#222",
            display: true,
          },
          ticks: {
            fontColor: "#71B37C",
          },
          labels: {
            labelMaxWidth: "10px",

            show: true,
          },
        },
        {
          labelMaxWidth: "10px",
          type: "linear",
          display: true,
          position: "right",
          id: "y-axis-2",
          gridLines: {
            color: "white",
            display: false,
          },
          ticks: {
            fontColor: "#FCFFCC",
          },
          labels: {
            show: true,
          },
        },
      ],
    },
  });

  export const plugins = [
    {
      id: "mouseLine",

      afterEvent: function (chart, e) {
        var chartArea = chart.chartArea;
        if (
          e.x >= chartArea.left &&
          e.y >= chartArea.top &&
          e.x <= chartArea.right &&
          e.y <= chartArea.bottom &&
          chart.active.length
        ) {
          chart.options.mouseLine.x = chart.active[0]._model.x;
        } else {
          chart.options.mouseLine.x = NaN;
        }
      },
      beforeDraw: function (c) {
        // var legends = c.legend.legendItems;
        //   legends.forEach(function(e) {
        //      e.fillStyle = 'red';
        //   });
      },

      afterDraw: function (chart, easing) {
        var ctx = chart.chart.ctx;
        var chartArea = chart.chartArea;
        var x = chart.options.mouseLine.x;

        if (!isNaN(x)) {
          ctx.save();
          ctx.strokeStyle = chart.options.mouseLine.color;
          ctx.lineWidth = 1;
          ctx.moveTo(chart.options.mouseLine.x, chartArea.bottom);
          ctx.lineTo(chart.options.mouseLine.x, chartArea.top);
          ctx.stroke();
          ctx.restore();
        }
      },
    },
  ];

 export const barDataFunc =(barLabel,barActualData)=> ({
    labels: barLabel,
    datasets: [
      {
        label: "Volume",
        backgroundColor: "#71B37C",
        borderColor: "#71B37C",
        borderWidth: 1,
        hoverBackgroundColor: "rgba(255,99,132,0.4)",
        hoverBorderColor: "rgba(255,99,132,1)",
        data: barActualData,
      },
    ],
  });

 export const barOptions = {
    maintainAspectRatio: false,
    responsive: true,
    tooltips: {
      mode: "label",
    },
    legend: {
      display: false,
    },
    layout: {
      padding: {
        left: 5,
        right: 5,
        top: 5,
        bottom: 5,
      },
    },
    elements: {
      line: {
        fill: false,
      },
    },
  };
 export const barOptionsMobile = {
    maintainAspectRatio: false,
    tooltips: {
      mode: "label",
    },
    legend: {
      display: false,
    },
    layout: {
      padding: {
        left: 0,
        right: 0,
        top: 0,
        bottom: 0,
      },
    },
    elements: {
      line: {
        fill: false,
      },
    },
  };


// WEBPACK FOOTER //
// ./src/components/Modals/VolumeModal/constant.js